import Flavours from "pages/flavours";
import FlavourDetails from "pages/flavours/details";
import FlavourDetailComponent from "pages/flavours/details/FlavourDetailComponent";

const routes = [
  // home
  {
    path: `/flavours`,
    exact: true,
    auth: true,
    component: Flavours,
  },
  // create
  {
    path: `/flavours/add`,
    exact: true,
    auth: true,
    component: FlavourDetails,
  },
  {
    path: `/flavours/update`,
    exact: true,
    auth: true,
    component: FlavourDetailComponent,
  },
];

export default routes;
